// src/components/GlobalFunction/SeoManager.js
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

const SITE_ORIGIN = "https://sehopro.com";
const SITE_NAME = "SEHO | SehoPro 台灣水禾";
const DEFAULT_IMAGE = `${SITE_ORIGIN}/img/Logo/LOGO-05.webp`;

const ROOT_SEO = {
  title: "SEHO | SehoPro｜台灣水禾",
  description: "SEHO | SehoPro 台灣水禾提供企業清潔衛生、食品衛生、手部消毒、器械清潔、一次性衛生耗材與環衛設備等專業解決方案。",
};

const DEFAULT_SEO = {
  title: "SEHO | SehoPro｜台灣水禾",
  description:
    "SEHO | SehoPro 台灣水禾提供企業清潔衛生、食品衛生、手部消毒、器械清潔、一次性衛生耗材與環衛設備等專業解決方案。",
};  

const PUBLIC_PAGE_SEO = {
  "/首頁": {
    title: "SEHO | SehoPro｜台灣水禾",
    description:
      "SEHO | SehoPro 台灣水禾提供企業清潔衛生、食品衛生、手部消毒、器械清潔、一次性衛生耗材與環衛設備等專業解決方案。",
  },

  "/關於水禾": {
    title: "關於水禾｜SEHO | SehoPro",
    description:
      "了解 SEHO | SehoPro 台灣水禾的品牌背景、服務經驗、企業理念與永續發展方向，打造更安全、更有效率的企業清潔衛生環境。",
  },

  "/公司簡介": {
    title: "公司簡介｜SEHO | SehoPro 台灣水禾",
    description:
      "SEHO | SehoPro 台灣水禾專注於企業清潔衛生與環衛產品整合服務，協助不同產業建立安心、穩定且高效率的清潔管理流程。",
  },

  "/品牌資訊": {
    title: "品牌資訊｜SEHO | SehoPro 台灣水禾",
    description:
      "瀏覽 SEHO | SehoPro 台灣水禾合作品牌與代理產品，包含企業清潔衛生、消毒、設備、耗材與食品衛生相關解決方案。",
  },

  "/企業責任": {
    title: "企業責任與永續發展 ESG｜台灣水禾",
    description:
      "台灣水禾重視企業責任、永續發展、環境保護與社會價值，持續推動更安全、更永續的清潔衛生方案。",
  },

  "/合作資訊": {
    title: "合作資訊｜台灣水禾企業合作與聯合開發",
    description:
      "台灣水禾提供企業合作、技術合作、聯合開發與招募資訊，歡迎與我們共同打造專業清潔衛生解決方案。",
  },

  "/合作資訊/技術合作及聯合開發諮詢": {
    title: "技術合作及聯合開發諮詢｜台灣水禾",
    description:
      "填寫合作諮詢表單，與台灣水禾討論技術合作、聯合開發、產品導入與企業清潔衛生方案。",
  },

  "/合作資訊/招募訊息": {
    title: "招募訊息｜加入台灣水禾",
    description:
      "查看台灣水禾招募資訊，加入專業企業清潔衛生與環衛產品服務團隊。",
  },

  "/聯絡水禾": {
    title: "聯絡水禾｜SEHO | SehoPro",
    description:
      "聯絡 SEHO | SehoPro 台灣水禾，取得企業清潔衛生、食品衛生、消毒產品、耗材設備與合作方案相關諮詢。",
  },

  "/商品資訊": {
    title: "商品資訊｜企業清潔用品、消毒產品與環衛設備",
    description:
      "瀏覽台灣水禾企業清潔衛生產品，包含手部消毒、食品衛生、器械清潔、一次性衛生耗材、設備與工具。",
  },

  "/商品資訊/專業諮詢(專人服務)": {
    title: "專業諮詢｜企業清潔衛生產品專人服務",
    description:
      "需要企業清潔衛生產品建議嗎？台灣水禾提供專人諮詢，協助選擇合適的清潔、消毒、耗材與設備方案。",
  },

  "/商品資訊/unique": {
    title: "產品特色｜台灣水禾企業清潔衛生解決方案",
    description:
      "了解台灣水禾產品特色與企業清潔衛生解決方案，協助不同產業建立更安全、更有效率的清潔流程。",
  },

  "/線上報修": {
    title: "線上報修｜台灣水禾客戶服務與設備維護申請",
    description:
      "台灣水禾客戶可透過線上報修表單提交設備維護、服務支援與相關問題，讓專人協助處理。",
  },

  "/最新資訊/": {
    title: "最新資訊｜SEHO | SehoPro 台灣水禾",
    description:
      "查看 SEHO | SehoPro 台灣水禾最新消息、活動資訊與衛生知識，掌握企業清潔衛生與食品安全相關趨勢。",
  },

  "/最新資訊/最新消息/": {
    title: "最新消息｜SEHO | SehoPro 台灣水禾",
    description:
      "查看 SEHO | SehoPro 台灣水禾最新公告、品牌動態、產品資訊與企業清潔衛生服務相關消息。",
  },

  "/最新資訊/活動資訊/": {
    title: "活動資訊｜SEHO | SehoPro 台灣水禾",
    description:
      "查看 SEHO | SehoPro 台灣水禾活動資訊、展覽消息、品牌活動與企業清潔衛生相關活動內容。",
  },

  "/最新資訊/衛生資訊/": {
    title: "衛生資訊｜企業清潔衛生與食品安全知識",
    description:
      "閱讀台灣水禾衛生資訊，了解食品衛生、手部消毒、清潔管理與企業環衛相關知識。",
  },

  "/隱私權": {
    title: "隱私權與使用條款｜台灣水禾",
    description: "查看台灣水禾網站隱私權政策、Cookie 使用說明與相關使用條款。",
  },

  "/網站地圖": {
    title: "網站地圖｜SEHO | SehoPro 台灣水禾",
    description:
      "瀏覽 SEHO | SehoPro 台灣水禾網站地圖，快速找到商品資訊、最新資訊、聯絡水禾、合作資訊與公司介紹。",
  },
};

function safeDecodePath(pathname) {
  try {
    return decodeURIComponent(pathname || "/");
  } catch {
    return pathname || "/";
  }
}

function normalizePath(pathname) {
  const decodedPath = safeDecodePath(pathname);
  const cleanPath = decodedPath.split("?")[0].split("#")[0];

  if (!cleanPath || cleanPath === "/") {
    return "/";
  }

  return cleanPath;
}

function encodePathForCanonical(pathname) {
  return String(pathname || "/")
    .split("/")
    .map((part) => encodeURIComponent(part))
    .join("/");
}

function isProductDetailPath(pathname) {
  const normalizedPath = normalizePath(pathname);

  return (
    normalizedPath.startsWith("/商品資訊/") &&
    normalizedPath !== "/商品資訊/專業諮詢(專人服務)" &&
    normalizedPath !== "/商品資訊/unique"
  );
}

function getVariantFromSearch(search) {
  try {
    const searchParams = new URLSearchParams(search || "");

    return String(searchParams.get("variant") || "").trim();
  } catch {
    return "";
  }
}

function getCanonicalUrl(pathname, search = "") {
  const normalizedPath = normalizePath(pathname);

  if (normalizedPath === "/" || normalizedPath === "/首頁") {
    return `${SITE_ORIGIN}/`;
  }

  const baseCanonicalUrl = `${SITE_ORIGIN}${encodePathForCanonical(
    normalizedPath,
  )}`;

  if (!isProductDetailPath(normalizedPath)) {
    return baseCanonicalUrl;
  }

  const variantId = getVariantFromSearch(search);

  if (!variantId) {
    return baseCanonicalUrl;
  }

  const canonicalSearchParams = new URLSearchParams();

  canonicalSearchParams.set("variant", variantId);

  return `${baseCanonicalUrl}?${canonicalSearchParams.toString()}`;
}

function shouldNoIndex(pathname) {
  const normalizedPath = normalizePath(pathname).toLowerCase();

  return (
    normalizedPath === "/auth" ||
    normalizedPath === "/profile" ||
    normalizedPath === "/404" ||
    normalizedPath === "/comingsoon" ||
    normalizedPath === "/搜尋" ||
    normalizedPath.startsWith("/checkout") ||
    normalizedPath.startsWith("/reset-password") ||
    normalizedPath.startsWith("/cms") ||
    normalizedPath.startsWith("/詢價") ||
    normalizedPath.startsWith("/我的收藏")
  );
}

function getSeoForPath(pathname) {
  const normalizedPath = normalizePath(pathname);

  if (normalizedPath === "/") {
    return ROOT_SEO;
  }

  if (PUBLIC_PAGE_SEO[normalizedPath]) {
    return PUBLIC_PAGE_SEO[normalizedPath];
  }

  if (normalizedPath.startsWith("/商品資訊/")) {
    return {
      title: "產品資訊｜台灣水禾企業清潔衛生產品",
      description:
        "查看台灣水禾企業清潔衛生產品資訊，了解產品特色、使用情境與專業清潔衛生解決方案。",
    };
  }

  if (normalizedPath.startsWith("/最新資訊/最新消息/")) {
    return {
      title: "最新消息｜台灣水禾 SehoPro",
      description:
        "查看台灣水禾最新消息，了解企業清潔衛生、產品服務與品牌相關資訊。",
    };
  }

  if (normalizedPath.startsWith("/最新資訊/衛生資訊/")) {
    return {
      title: "衛生資訊｜台灣水禾企業清潔衛生知識",
      description:
        "閱讀台灣水禾衛生資訊，了解食品衛生、手部消毒、清潔管理與企業環衛相關知識。",
    };
  }

  return DEFAULT_SEO;
}

function upsertMetaByName(name, content) {
  if (!content || typeof document === "undefined") {
    return;
  }

  let element = document.querySelector(`meta[name="${name}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("name", name);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function upsertMetaByProperty(property, content) {
  if (!content || typeof document === "undefined") {
    return;
  }

  let element = document.querySelector(`meta[property="${property}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute("property", property);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
}

function upsertCanonical(href) {
  if (!href || typeof document === "undefined") {
    return;
  }

  let element = document.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  if (!id || !data || typeof document === "undefined") {
    return;
  }

  let element = document.getElementById(id);

  if (!element) {
    element = document.createElement("script");
    element.id = id;
    element.type = "application/ld+json";
    document.head.appendChild(element);
  }

  element.textContent = JSON.stringify(data);
}

function removeJsonLd(id) {
  if (typeof document === "undefined") {
    return;
  }

  const element = document.getElementById(id);

  if (element) {
    element.remove();
  }
}

function getOrganizationJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "台灣水禾實業有限公司",
    alternateName: [
      "SEHO",
      "SehoPro",
      "SEHO Pro",
      "SEHOPRO",
      "台灣水禾",
      "水禾",
    ],
    url: SITE_ORIGIN,
    logo: DEFAULT_IMAGE,
  };
}

function getWebsiteJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    alternateName: [
      "SEHO",
      "SehoPro",
      "SEHO Pro",
      "SEHOPRO",
      "台灣水禾",
    ],
    url: SITE_ORIGIN,
    potentialAction: {
      "@type": "SearchAction",
      target: `${SITE_ORIGIN}/%E6%90%9C%E5%B0%8B?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
}

export default function SeoManager() {
  const location = useLocation();

  const seo = useMemo(() => {
    const pageSeo = getSeoForPath(location.pathname);

    const canonicalUrl = getCanonicalUrl(location.pathname, location.search);

    const noIndex = shouldNoIndex(location.pathname);

    return {
      ...pageSeo,
      canonicalUrl,
      noIndex,
    };
  }, [location.pathname, location.search]);

  useEffect(() => {
    const isRootPage = seo.canonicalUrl === `${SITE_ORIGIN}/`;

    const fullTitle = isRootPage
      ? seo.title
      : seo.title.includes("台灣水禾")
        ? seo.title
        : `${seo.title}｜台灣水禾`;

    document.documentElement.setAttribute("lang", "zh-Hant");
    document.title = fullTitle;

    upsertMetaByName("description", seo.description);
    upsertMetaByName(
      "robots",
      seo.noIndex ? "noindex, nofollow" : "index, follow",
    );

    upsertCanonical(seo.canonicalUrl);

    upsertMetaByProperty("og:type", "website");
    upsertMetaByProperty("og:site_name", SITE_NAME);
    upsertMetaByProperty("og:title", fullTitle);
    upsertMetaByProperty("og:description", seo.description);
    upsertMetaByProperty("og:url", seo.canonicalUrl);
    upsertMetaByProperty("og:image", DEFAULT_IMAGE);
    upsertMetaByProperty("og:locale", "zh_TW");

    upsertMetaByName("twitter:card", "summary_large_image");
    upsertMetaByName("twitter:title", fullTitle);
    upsertMetaByName("twitter:description", seo.description);
    upsertMetaByName("twitter:image", DEFAULT_IMAGE);

    if (seo.noIndex) {
      removeJsonLd("seho-organization-jsonld");
      removeJsonLd("seho-website-jsonld");
      return;
    }

    upsertJsonLd("seho-organization-jsonld", getOrganizationJsonLd());
    upsertJsonLd("seho-website-jsonld", getWebsiteJsonLd());
  }, [seo]);

  return null;
}
